<script setup lang="ts">
</script>

<template>
    <v-chip
        color="green-darken-1"
        class="ml-1 text-caption text-capitalize"
        size="x-small"
    >
        It's you
    </v-chip>
</template>

<style scoped>

</style>
